import { Avatar } from '@mui/material'
import React, { FC } from 'react'
import { HiQuestionMarkCircle } from 'react-icons/hi2'

interface Props {
  logo?: string
  size?: number
}

const TokenAvatar: FC<Props> = ({ logo, size }) => {
  return (
    <Avatar sx={size ? { height: size, width: size } : {}} src={logo}>
      {!logo && <HiQuestionMarkCircle />}
    </Avatar>
  )
}

export default TokenAvatar
